const hasRouteSegment = (path: string, segment: string) => path.split('/').filter(Boolean).includes(segment);

const shouldEnsureShopwareSession = (path: string) => hasRouteSegment(path, 'shop') || hasRouteSegment(path, 'account');

/**
 * Ensures Shopware session context is refreshed for storefront-related routes
 * that include the `shop` or `account` path segment.
 *
 * - Skip on server-side execution.
 * - Skip routes without `shop`/`account` as a dedicated path segment.
 * - Trigger a best-effort session-context refresh through
 *   `useEnsureShopwareSession`.
 *
 * @param to Destination route that is being entered.
 * @returns Nothing. Navigation continues even if refresh fails.
 */
export default defineNuxtRouteMiddleware(async (to) => {
    if (import.meta.server) return;
    if (!shouldEnsureShopwareSession(to.path)) return;

    const { ensureShopwareSession } = useEnsureShopwareSession();
    await ensureShopwareSession({ reason: `route:${to.path}` });
});
